// ============================================
// CATALOGO UNICO DE ROLES — espejo del backend
// ============================================
// PERM-1 (FASE A0): mantener sincronizado con src/constants/roles.js
// Si agregas un rol aqui, tambien agregalo en backend.

export const ROLES = {
  DIRECCION:      'direccion',
  ADMINISTRACION: 'administracion',
  GERENTE:        'gerente',
  MARKETING:      'marketing',
  ALMACEN:        'almacen',
  OPERACIONES:    'operaciones',
  TECNICO:        'tecnico',
  VIEWER:         'viewer',
  // CONTRATISTAS-EXTERNOS Bloque 2 (2026-10-15): espejo de src/constants/roles.js
  COORDINADOR:    'coordinador',
  CONTRATISTA_EXTERNO: 'contratista_externo',
};

export const ROLES_LISTA = Object.values(ROLES);

export const ROLES_LABELS = {
  [ROLES.DIRECCION]:      'Direccion',
  [ROLES.ADMINISTRACION]: 'Administracion',
  [ROLES.GERENTE]:        'Gerente',
  [ROLES.MARKETING]:      'Marketing',
  [ROLES.ALMACEN]:        'Almacen',
  [ROLES.OPERACIONES]:    'Operaciones',
  [ROLES.TECNICO]:        'Tecnico',
  [ROLES.VIEWER]:         'Viewer (solo lectura)',
  [ROLES.COORDINADOR]:    'Coordinador',
  [ROLES.CONTRATISTA_EXTERNO]: 'Contratista externo',
};

// Roles que se pueden CREAR desde Usuarios: el externo nace solo por invitacion (pantalla Contratistas).
export const ROLES_CREABLES = ROLES_LISTA.filter(r => r !== ROLES.CONTRATISTA_EXTERNO);

export const ROLES_ADMIN = [ROLES.DIRECCION, ROLES.ADMINISTRACION];
export const ROLES_OPERATIVOS = [ROLES.GERENTE, ROLES.MARKETING, ROLES.ALMACEN, ROLES.OPERACIONES, ROLES.TECNICO];
